import api from './api';

export interface TaskItem {
  id: string;
  title: string;
  notes?: string;
  status: 'needsAction' | 'completed';
  due?: string | null;
  completed?: string | null;
  updated?: string | null;
}

export async function listTasklists(userId?: string) {
  const params: any = {};
  if (userId) params.user_id = userId;
  const res = await api.get('/tasks/lists', { params });
  return (res.data?.data || []) as Array<{ id: string; title: string }>;
}

export async function listTasks(tasklistId: string, opts?: { showCompleted?: boolean; maxResults?: number; userId?: string }) {
  const params: any = { tasklistId };
  if (opts?.showCompleted !== undefined) params.showCompleted = String(opts.showCompleted);
  if (opts?.maxResults) params.maxResults = String(opts.maxResults);
  if (opts?.userId) params.user_id = opts.userId;
  const res = await api.get('/tasks/items', { params });
  return (res.data?.data || []) as TaskItem[];
}

export async function createTask(tasklistId: string, payload: { title: string; notes?: string; due?: string | null }, opts?: { userId?: string }) {
  const body: any = { tasklistId, ...payload };
  if (opts?.userId) body.user_id = opts.userId;
  const res = await api.post('/tasks/items', body);
  return res.data?.data;
}

export async function completeTask(tasklistId: string, taskId: string) {
  const res = await api.post('/tasks/complete', { tasklistId, taskId });
  return res.data?.data;
}

export async function deleteTask(tasklistId: string, taskId: string) {
  try {
    const res = await api.post('/tasks/delete', { tasklistId, taskId });
    return res.data?.success === true;
  } catch (e: any) {
    // fallback alias
    const res2 = await api.post('/tasks/items/delete', { tasklistId, taskId });
    return res2.data?.success === true;
  }
}

export async function updateTask(tasklistId: string, taskId: string, payload: { title?: string; due?: string | null; status?: 'needsAction' | 'completed' }) {
  const res = await api.post('/tasks/update', { tasklistId, taskId, ...payload });
  return res.data?.data;
}

export async function migrateTasksToLocal(): Promise<{ createdLists?: number; createdTasks?: number; alreadyMigrated?: boolean }> {
  const res = await api.post('/tasks/migrate-local', {});
  return res.data || {};
}


